// extracted by mini-css-extract-plugin
export default {"equal":"Equal_equal__OuzEf","equal_black":"Equal_equal_black__+Y0jZ"};